import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    baseUrl: string;
};

const AccountSettingsPageHeaderMeta = ({ baseUrl }: Props) => {
    const { formatMessage } = useIntl();

    const title = useAddNotificationCountToTitle(formatMessage({ id: 'accountSettings.title' }));
    const description = formatMessage({ id: 'accountSettings.description' });
    const canonical = `${baseUrl}/dashboard/profile`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo<Props>(AccountSettingsPageHeaderMeta);
